import PropTypes from "prop-types";
import { BounceEffect } from "./helpers/bounceeffect";
import {
  UPDATE_VIEWPORT_CATEGORY,
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT,
  SET_GENDER,
  OPEN_SIDE_PANEL,
  CLOSE_SIDE_PANEL,
  MALE,
  FEMALE,
  DEFAULT,
  SET_GEO_COUNTRY,
  REMOVE_LAST_ACTIVE_ELEMENT,
  ADD_LAST_ACTIVE_ELEMENT,
  CLEAR_LAST_ACTIVE_ELEMENTS
} from "./constants";
import {
  OPEN_SEARCH,
  CLOSE_SEARCH
} from "@template/state/modules/search/constants";
import {
  OPEN_COUNTRY_SELECTOR,
  CLOSE_COUNTRY_SELECTOR
} from "@template/state/modules/countrySelector/constants";

export {
  MALE,
  FEMALE,
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT,
  DEFAULT,
  SECURE
} from "./constants";

export {
  setGender,
  openSidePanel,
  closeSidePanel,
  publishGeoCountry,
  updateViewportCategory,
  focusLastActiveElement,
  addLastFocusElement
} from "./actions";

export {
  isFemale,
  isMale,
  hasGender,
  isSidePanelOpen,
  getViewport,
  isCookieMessageOpen,
  getCurrentGender,
  getPlatform,
  getLastActiveElements,
  getGeoCountry
} from "./selectors";

export const genderPropType = PropTypes.oneOf([MALE, FEMALE, DEFAULT]);
export const viewportPropType = PropTypes.oneOf([
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
]);

const initialState = {
  viewportCategory: SMALL_VIEWPORT,
  isSidePanelOpen: false,
  isCookieMessageOpen: false,
  gender: DEFAULT,
  platform: "desktop",
  lastActiveElements: []
};

const needsBounceEffect = () => {
  const testDiv = document.createElement("div");
  document.documentElement.appendChild(testDiv);
  testDiv.style.WebkitOverflowScrolling = "touch";
  const scrollSupport =
    "getComputedStyle" in window &&
    window.getComputedStyle(testDiv)["-webkit-overflow-scrolling"] === "touch";
  document.documentElement.removeChild(testDiv);
  return scrollSupport;
};

BounceEffect.disable();

const validateViewport = (state, viewportCategory) =>
  [SMALL_VIEWPORT, MEDIUM_VIEWPORT, LARGE_VIEWPORT].includes(viewportCategory)
    ? viewportCategory
    : state.viewportCategory;

export default (state = initialState, action) => {
  let lastFocusElementIndex;
  switch (action.type) {
    case UPDATE_VIEWPORT_CATEGORY:
      return {
        ...state,
        viewportCategory: validateViewport(
          state,
          action.payload.viewportCategory
        )
      };
    case SET_GENDER:
      return {
        ...state,
        gender: action.payload
      };
    case OPEN_SIDE_PANEL:
      document.body.classList.add("chrome-hide-overflow");
      if (needsBounceEffect()) {
        BounceEffect.enable();
      }
      return {
        ...state,
        isSidePanelOpen: true,
        isMainAppHidden: true
      };
    case CLOSE_SIDE_PANEL:
      document.body.classList.remove("chrome-hide-overflow");
      BounceEffect.disable();
      return {
        ...state,
        isSidePanelOpen: false,
        isMainAppHidden: false
      };
    case SET_GEO_COUNTRY:
      return {
        ...state,
        geoCountry: action.payload
      };
    case OPEN_SEARCH: {
      if (action.payload.isModal) {
        return {
          ...state,
          isMainAppHidden: true
        };
      }

      return state;
    }
    case CLOSE_SEARCH: {
      if (action.payload.isModal) {
        return {
          ...state,
          isMainAppHidden: false
        };
      }

      return state;
    }
    case OPEN_COUNTRY_SELECTOR:
      return {
        ...state,
        isMainAppHidden: true
      };
    case CLOSE_COUNTRY_SELECTOR:
      return {
        ...state,
        isMainAppHidden: false
      };
    case ADD_LAST_ACTIVE_ELEMENT:
      return {
        ...state,
        lastActiveElements: [...state.lastActiveElements, action.activeElement]
      };
    case CLEAR_LAST_ACTIVE_ELEMENTS:
      lastFocusElementIndex = state.lastActiveElements.indexOf(
        action.forceElementFocus
      );

      return {
        ...state,
        lastActiveElements:
          lastFocusElementIndex > 0
            ? state.lastActiveElements.slice(0, lastFocusElementIndex)
            : []
      };
    case REMOVE_LAST_ACTIVE_ELEMENT:
      if (
        action.lastActiveElement ===
        state.lastActiveElements[state.lastActiveElements.length - 1]
      )
        return {
          ...state,
          lastActiveElements: [...state.lastActiveElements.slice(0, -1)]
        };
      return state;
  }

  return state;
};
